import { useEffect } from "react"
import { useLocation } from "react-router-dom"
import { useAuthStore } from "@/features/auth/store/authStore"
import { AppLayout } from "./AppLayout"
import { PublicLayout } from "./PublicLayout"

function ScrollToTop() {
  const { pathname } = useLocation()

  // biome-ignore lint/correctness/useExhaustiveDependencies: pathname triggers scroll on route change
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}

interface AuthAwareLayoutProps {
  children?: React.ReactNode
}

export function AuthAwareLayout({ children }: AuthAwareLayoutProps) {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated())

  if (isAuthenticated) {
    return (
      <>
        <ScrollToTop />
        <AppLayout>{children}</AppLayout>
      </>
    )
  }

  return (
    <>
      <ScrollToTop />
      <PublicLayout>{children}</PublicLayout>
    </>
  )
}
